export default __webpack_public_path__ + "static/media/151-real-estate-5.a8d67469.png";